// extracted by mini-css-extract-plugin
export default {"formSearch":"search_formSearch__m4tMx","search__button":"search_search__button__dGgvP","search__img":"search_search__img__JgN6o","search__input":"search_search__input__4b0ef"};